export const LODGING_INSTRUCTION = {
    title: '房客入住守则',
    abstraction: '为了营造安全舒适的居住环境和保障租赁双方的合法权益，请仔细阅读并遵守本守则。',
    protocols: [
        {
            name: '入住前：',
            list: [
                { text: '检查房屋内的设施功能，若使用异常，请联系房东及时维修和更换；' },
                { text: '与房东确定房东能提供的服务范围如保洁、维修等；' },
                { text: '与房东签订《房屋租赁合同》，保障自己的合法权益；' },
                { text: '签租房合同时注意租期长短，租期未满提前退租是一种违约行为。' },
            ]
        },
        {
            name: '入住后：',
            list: [
                { text: '保持屋内整洁，处理并做好生活垃圾分类；' },
                { text: '晚上11点之后保持安静，不大声喧哗、打闹，不人为制造噪音，不妨碍别人休息；' },
                { text: '禁止在房屋内从事违法犯罪行为，如赌博、卖淫、吸毒、偷窥、偷窃、斗殴等；' },
                { text: '禁止在房屋内的公用区域吸烟；' },
                { text: '禁止破坏房屋结构，若有新增的装饰和装修需先征得房东书面同意；' },
                { text: '遵守安全用电的有关规定，不偷电，不私拉乱接电线和电源，不超负荷使用电器设备。使用大功率电器时注意使用安全，做到用时人在场，用后及时关闭断电；' },
                { text: '出入关好门窗，外出时关灯关水关电关煤气，时刻注意防盗，防火，防事故，保证自己和他人的生命和财产安全；' },
                { text: '现金等贵重物品必须妥善保管，如有丢失，责任自负；' },
                { text: '设备设施发生故障或损坏时及时报告房东，如电器故障、水电煤泄漏等；' },
                { text: '按时、足额向房东支付房租和水电煤等费用；' },
                { text: '租赁期间若要新增同住人，需先征得房东同意；' },
                { text: '租赁期间若要转租房屋需先征得房东同意；' },
                { text: '租赁关系终止时与房东签订《解约协议》，并完成房屋交割和费用清算；' },
                { text: '遵守所在小区和城市的相关法律法规的规定。' }
            ]
        },
        {
            name: '平台声明：',
            intro: '房客需遵守以上入住规则，若有违反，经房东多次书面警告无效的，房东有权单方面无责任解除租房合同。'
        }
    ]
}